// extracted by mini-css-extract-plugin
module.exports = {"actions":"styles_actions__1ce8E","col":"styles_col__1rSPg"};